import { render, staticRenderFns } from "./AssociationsTable.vue?vue&type=template&id=34fed648&scoped=true&"
import script from "./AssociationsTable.vue?vue&type=script&lang=js&"
export * from "./AssociationsTable.vue?vue&type=script&lang=js&"
import style0 from "./AssociationsTable.vue?vue&type=style&index=0&id=34fed648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fed648",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34fed648')) {
      api.createRecord('34fed648', component.options)
    } else {
      api.reload('34fed648', component.options)
    }
    module.hot.accept("./AssociationsTable.vue?vue&type=template&id=34fed648&scoped=true&", function () {
      api.rerender('34fed648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AssociationsTable.vue"
export default component.exports